import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { AppliedFacetFilter } from 'components/FacetFilters';
import { ParsedUrlQuery } from 'querystring';

export const useApplyFacetFilterFromURL = () => {
  const [appliedFacetFilters, setAppliedFacetFilter] = useState<
    AppliedFacetFilter[]
  >([]);
  const [isAppliedFiltersLoading, setIsAppliedFiltersLoading] =
    useState<boolean>(true);

  const router = useRouter();

  useEffect(() => {
    if (!router?.isReady) return;

    const routerFilterQuery = router?.query;
    const appliedFilters = buildFiltersFromURLQueryString(routerFilterQuery);
    setAppliedFacetFilter(appliedFilters);
    setIsAppliedFiltersLoading(false);
  }, [router?.query]);

  const onRemoveAllFacetFilter = () => {
    router.push(
      {
        ...router,
        query: {
          slug: router.query.slug,
        },
      },
      undefined,
      { shallow: true }
    );
  };

  const onRemoveFacetFilter = (filterKey: string, filterValue: string) => {
    const newFilters = appliedFacetFilters.filter(
      propertyFilter =>
        !(
          propertyFilter.filterKey === filterKey &&
          propertyFilter.filterValue === filterValue
        )
    );

    const acc = newFilters.reduce(
      (acc: { [key: string]: string }, filter: AppliedFacetFilter) => {
        if (acc[filter.filterKey]) {
          acc[filter.filterKey] =
            acc[filter.filterKey] + ',' + filter.filterValue;
        } else {
          acc[filter.filterKey] = filter.filterValue;
        }

        return acc;
      },
      {}
    );
    router.push(
      {
        ...router,
        query: {
          slug: router.query.slug,
          ...acc,
        },
      },
      undefined,
      { shallow: true }
    );
  };

  const onSelectFacetFilter = (
    filterKey: string,
    filterValue: string,
    isSelected: boolean
  ) => {
    let newFilters;
    console.log('isSelected', isSelected);
    console.log('filterKey', filterKey);
    console.log('filterValue', filterValue);
    if (isSelected) {
      newFilters = [
        ...appliedFacetFilters,
        {
          filterKey: filterKey,
          filterValue: filterValue,
        },
      ];
      console.log('newFilters', newFilters);
    } else {
      newFilters = appliedFacetFilters.filter(
        propertyFilter =>
          !(
            propertyFilter.filterKey === filterKey &&
            propertyFilter.filterValue === filterValue
          )
      );
    }

    const acc = newFilters.reduce(
      (acc: { [key: string]: string }, filter: AppliedFacetFilter) => {
        if (acc[filter.filterKey]) {
          acc[filter.filterKey] =
            acc[filter.filterKey] + ',' + filter.filterValue;
        } else {
          acc[filter.filterKey] = filter.filterValue;
        }
        return acc;
      },
      {}
    );

    console.log('accumulator::', acc);

    router.replace(
      {
        ...router,
        query: {
          slug: router.query.slug,
          ...acc,
        },
      },
      undefined,
      { shallow: true }
    );
  };

  const buildFiltersFromURLQueryString = (
    routerFilterQuery: ParsedUrlQuery
  ) => {
    const appliedFilters: AppliedFacetFilter[] = [];
    if (routerFilterQuery && !routerFilterQuery?.length) {
      const source = routerFilterQuery;

      for (const property in source) {
        if (source[property] && property !== 'slug') {
          const baseAttributes = {
            filterKey: property,
          };
          (source[property] as string).split(',').forEach(filterValueParam => {
            const appliedFilter: AppliedFacetFilter = {
              ...baseAttributes,
              filterValue: filterValueParam,
            };
            if (appliedFilter) appliedFilters.push(appliedFilter);
          });
        }
      }
    }
    console.log('appliedFilters at 166', appliedFilters);
    return appliedFilters;
  };

  return {
    isAppliedFiltersLoading,
    appliedFacetFilters,
    onSelectFacetFilter,
    onRemoveFacetFilter,
    onRemoveAllFacetFilter,
  };
};
